export default "__VITE_ASSET__Cwnyf_X5__"